import { createContext, ReactNode, useContext } from 'react'

export type ModalApplicationActions = {
  title: string
  description?: string | ReactNode
  cancelText?: string
  confirmText?: string
  onCancel?: () => void
  onConfirm?: () => void | Promise<void>
  isLoading?: boolean
  showButtons?: boolean
  disabled?: boolean
}

export type ModalApplicationContextProps = ModalApplicationActions & {
  handleModal: (props: Omit<ModalApplicationActions, 'handleModal'>) => void
  updateModal: (
    props: Partial<Omit<ModalApplicationActions, 'handleModal'>>,
  ) => void
  toggleLoading: () => void
  resetModal: () => void
}

export const ModalApplicationContext =
  createContext<ModalApplicationContextProps>(
    {} as ModalApplicationContextProps,
  )

export const useModalApplication = () => {
  const context = useContext(ModalApplicationContext)

  if (!context) {
    throw new Error(
      'useModalApplication must be used within a ModalApplicationProvider',
    )
  }

  return context
}
